/* eslint-disable jsx-a11y/alt-text */
import React, { memo, useEffect, useState, useContext } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Box from '@material-ui/core/Box'
import { Typography } from '@material-ui/core'

import { getDefaultCfdImage } from '../../utils/images'

import ImageVersioningContext from '../../context/ImageVersioningContext'

export const VNIdle = memo((props) => {
  const defaultImage = getDefaultCfdImage()

  const [menuImage, setMenuImage] = useState(props.menuImage)
  const [standImage, setStandImage] = useState(props.standImage || defaultImage)

  const imageVersioningContext = useContext(ImageVersioningContext)
  const storedImageVersion = localStorage.getItem('image_version')
  imageVersioningContext.setImageVersion(storedImageVersion)

  const useStyles = makeStyles((theme) => ({
    root: {
      height: '100%',
      backgroundColor: props.color,
    },
    image: {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
    },
    title: {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%);',
    },
    versionBox: {
      backgroundColor: '#000000',
      position: 'absolute',
      bottom: 10,
      left: 10,
      padding: 8,
    },
  }))

  const classes = useStyles()

  // need to ensure that this forces a change if we do get it updated from state
  useEffect(() => {
    // The menu image's fallback is the stand image.
    setMenuImage(props.menuImage)

    // The stand image's fallback is the default image.
    setStandImage(props.standImage || defaultImage)
  }, [props.standImage, props.menuImage, defaultImage])

  const display = () => {
    if (menuImage) {
      return (
        <img
          src={imageVersioningContext.getUrlWithVersion(menuImage)}
          className={classes.image}
          onError={() => {
            // The menu image's fallback is the stand image. Set the me
            setMenuImage(null)
          }}
        />
      )
    } else if (standImage) {
      return (
        <img
          src={imageVersioningContext.getUrlWithVersion(standImage)}
          className={classes.image}
          onError={() => {
            setStandImage(defaultImage)
          }}
        />
      )
    } else {
      return (
        <Typography variant="h1" className={classes.title}>
          {props.title}
        </Typography>
      )
    }
  }

  return (
    <Box className={classes.root}>
      {display()}
      <Box className={classes.versionBox}>
        <Typography variant="h5">{process.env.REACT_APP_VERSION}</Typography>
      </Box>
    </Box>
  )
})
